<app-status-bar></app-status-bar>

<div class="reserva-detail-wrapper">
  <div class="header-wrapper">
    <div class="back-button" (click)="goBack()">
      <fa-icon [icon]="faArrowLeft"></fa-icon>
      <p>Reservas</p>
    </div>
  </div>

  <!-- Loading -->
  <div class="loading-wrapper" *ngIf="loading">
    <mat-progress-spinner color="accent" mode="indeterminate" diameter="50">
    </mat-progress-spinner>
  </div>

  <div class="content-wrapper" *ngIf="!loading && reservation">
    <!-- Título editable -->
    <div class="title-wrapper">
      <div class="title-row" *ngIf="!editingName">
        <fa-icon [icon]="faBookmark" class="bookmark-icon"></fa-icon>
        <span class="reservation-name">{{ reservation.name }}</span>
        <span class="reservation-company" *ngIf="reservation.company">
          | {{ reservation.company }}
        </span>
        <span class="status-badge" [class]="reservation.cart?.status?.name || 'pending'">
          {{ getStatusLabel(reservation.cart?.status?.name) }}
        </span>
        <button class="btn-icon" (click)="startEditName()" title="Renombrar reserva" *ngIf="!isReadOnly">
          <fa-icon [icon]="faPencil"></fa-icon>
        </button>
      </div>
      <div class="title-edit-row" *ngIf="editingName">
        <input
          class="name-edit-input"
          type="text"
          [(ngModel)]="editNameValue"
          (keyup.enter)="saveName()"
          (keyup.escape)="cancelEditName()"
          autofocus
        />
        <button class="btn-icon btn-success" (click)="saveName()" title="Guardar">
          <fa-icon [icon]="faCheck"></fa-icon>
        </button>
        <button class="btn-icon btn-cancel" (click)="cancelEditName()" title="Cancelar">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>
    </div>

    <!-- Card principal con acciones y líneas -->
    <div class="detail-card">
      <!-- Cabecera con acciones -->
      <div class="detail-card-header">
        <div class="card-title">
          Entradas / Asientos
          <span class="lines-count">({{ reservationLines.length }})</span>
        </div>
        <div class="action-button secondary-button" (click)="goToOrder()" *ngIf="orderInvoicingId">
            <fa-icon [icon]="faFileInvoice"></fa-icon>
            <p>Ver pedido</p>
          </div>
        <div class="action-buttons-wrapper" *ngIf="!isReadOnly">
          <div class="action-button danger-button" (click)="deleteReservation()">
            <fa-icon [icon]="faTrash"></fa-icon>
            <p>Eliminar reserva</p>
          </div>
          <div class="action-button secondary-button"
            (click)="isReserved ? addTickets() : null"
            [class.disabled-btn]="!isReserved"
            [title]="isReserved ? 'Añadir entradas' : 'Solo se pueden añadir entradas cuando la reserva está en estado Reservada'">
            <fa-icon [icon]="faPlus"></fa-icon>
            <p>Añadir entradas</p>
          </div>
          <div
            class="action-button primary-button"
            (click)="finalizePurchase()"
            [class.disabled-btn]="reservationLines.length === 0"
          >
            <fa-icon [icon]="faTicket"></fa-icon>
            <p>Finalizar compra</p>
          </div>
        </div>
      </div>

      <!-- Sin líneas -->
      <div class="empty-lines" *ngIf="reservationLines.length === 0">
        <p>No hay entradas en esta reserva todavía.</p>
        <button class="btn-add-inline" (click)="addTickets()" *ngIf="isReserved && !isReadOnly">
          <fa-icon [icon]="faPlus"></fa-icon>
          <span>Añadir entradas</span>
        </button>
        <p class="no-add-hint" *ngIf="!isReserved || isReadOnly">Esta reserva no admite más entradas en su estado actual.</p>
      </div>

      <!-- Listado agrupado por evento/sesión -->
      <div class="lines-list" *ngIf="reservationLines.length > 0">

        <div *ngFor="let group of groupedLines; trackBy: trackByGroup" class="event-group-wrapper">

          <!-- Cabecera del grupo -->
          <div class="event-group-header" (click)="toggleGroup(group.groupKey)">
            <div class="event-group-img">
              <img *ngIf="group.event?.image_url" [src]="urlImages + group.event.image_url" />
              <div class="event-group-img-placeholder" *ngIf="!group.event?.image_url">
                <fa-icon [icon]="faTicket"></fa-icon>
              </div>
            </div>
            <div class="event-group-info">
              <span class="event-group-title">{{ group.event?.title }}</span>
              <span class="event-group-session">
                <fa-icon [icon]="faCalendar"></fa-icon>
                {{ group.session?.start_date | date:'dd MMM yyyy · HH:mm':'+0000' }}h
                &nbsp;·&nbsp;
                {{ group.quantityTotal }} entrada{{ group.quantityTotal > 1 ? 's' : '' }}
              </span>
            </div>
            <span class="event-group-total">{{ group.total | number:'1.2-2' }} €</span>
            <fa-icon class="event-group-chevron" [icon]="faChevron" [class.rotated]="!group.expanded"></fa-icon>
          </div>

          <!-- Líneas del grupo -->
          <div *ngIf="group.expanded">
            <div *ngFor="let line of group.lines; trackBy: trackByLine" class="line-card">
              <div class="line-row">
                <!-- Info: nombre + asiento -->
                <div class="line-info">
                  <span class="ticket-name">
                    {{ line.ticket?.name || '—' }}
                    <span *ngIf="line.quantity && line.quantity > 1" class="qty-badge">×{{ line.quantity }}</span>
                  </span>
                  <span class="seat-info" *ngIf="getLineSeatInfo(line)">
                    <fa-icon [icon]="faLoveseat"></fa-icon>
                    {{ getLineSeatInfo(line) }}
                  </span>
                </div>

                <!-- Edición de cantidad (solo sin asiento) -->
                <div class="qty-edit" *ngIf="editingLineId === line.id && !isReadOnly">
                  <input type="number" min="1" [(ngModel)]="editLineQuantity"
                    (keyup.enter)="saveLineQuantity(line)" (keyup.escape)="cancelEditLine()" />
                  <button class="btn-icon btn-success" (click)="saveLineQuantity(line)"><fa-icon [icon]="faCheck"></fa-icon></button>
                  <button class="btn-icon btn-cancel" (click)="cancelEditLine()"><fa-icon [icon]="faTimes"></fa-icon></button>
                </div>

                <!-- Precio -->
                <div class="line-price-block">
                  <ng-container *ngIf="line.discount_total > 0; else noLineDiscount">
                    <span class="line-price-original">{{ line.price_original | number:'1.2-2' }} €</span>
                    <span class="line-price line-price--discounted">{{ line.price_with_discount | number:'1.2-2' }} €</span>
                  </ng-container>
                  <ng-template #noLineDiscount>
                    <span class="line-price">{{ (line.price_with_discount ?? (+line.price - +line.fee)) | number:'1.2-2' }} €</span>
                  </ng-template>
                </div>

                <!-- Acciones -->
                <div class="line-actions" *ngIf="!isReadOnly">
                  <button class="btn-icon"
                    *ngIf="!getLineSeatInfo(line) && editingLineId !== line.id"
                    (click)="startEditLine(line)" title="Editar cantidad">
                    <fa-icon [icon]="faPencil"></fa-icon>
                  </button>
                  <button class="btn-icon btn-danger" (click)="deleteLine(line)" title="Eliminar">
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Subtotales -->
        <div class="res-totals-wrapper">
          <div class="res-totals-inner">

          <ng-container *ngIf="totalOrder; else fallbackTotal">

            <div class="res-totals-row">
              <span class="res-totals-label">Subtotal</span>
              <span class="res-totals-value">{{ totalOrder.subtotal_without_discount | number:'1.2-2' }} €</span>
            </div>

            <ng-container *ngIf="hasDiscounts">
              <div class="res-totals-row res-totals-row--discount res-totals-row--expandable"
                   (click)="discountExpanded = !discountExpanded">
                <span class="res-totals-label">
                  Descuentos
                  <fa-icon [icon]="faChevron" class="res-totals-chevron" [class.rotated]="discountExpanded"></fa-icon>
                </span>
                <span class="res-totals-value">-{{ totalOrder.discount_total | number:'1.2-2' }} €</span>
              </div>
              <ng-container *ngIf="discountExpanded">
                <div class="res-totals-row res-totals-row--sub" *ngFor="let d of appliedDiscounts">
                  <span class="res-totals-label">
                    <fa-icon [icon]="faPercent"></fa-icon>
                    {{ d.public_name }}
                  </span>
                  <span class="res-totals-value">-{{ d.discount_total | number:'1.2-2' }} €</span>
                </div>
                <div class="res-totals-row res-totals-row--sub" *ngFor="let promo of promoCodeDiscounts">
                  <span class="res-totals-label">
                    <fa-icon [icon]="faTag"></fa-icon>
                    {{ promo.public_name }}
                  </span>
                  <span class="res-totals-value">-{{ promo.amount | number:'1.2-2' }} €</span>
                </div>
              </ng-container>
            </ng-container>

            <div class="res-totals-row" *ngIf="(+totalOrder.fee_total) > 0">
              <span class="res-totals-label">Comisión</span>
              <span class="res-totals-value">{{ totalOrder.fee_total | number:'1.2-2' }} €</span>
            </div>

            <div class="res-totals-row res-totals-row--total">
              <span class="res-totals-label">{{ totalQuantity }} entrada{{ totalQuantity !== 1 ? 's' : '' }}</span>
              <span class="res-totals-value">{{ totalOrder.total | number:'1.2-2' }} €</span>
            </div>

          </ng-container>

          <ng-template #fallbackTotal>
            <div class="res-totals-row res-totals-row--total">
              <span class="res-totals-label">{{ totalQuantity }} entrada{{ totalQuantity !== 1 ? 's' : '' }}</span>
              <span class="res-totals-value">{{ reservationTotal | number:'1.2-2' }} €</span>
            </div>
          </ng-template>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
